import React from "react";
import { useTranslation } from "react-i18next";
import FormatResourceStatusLabel from "go-app/components/FormatResourceStatus/FormatResourceStatus";
import { getComponentStatusClassName } from "go-component/Common/FormatStatus";
import { StocktakingStatus } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	status: StocktakingStatus;
}

const getStatusClassName = (status: StocktakingStatus) => {
	let labelClass = getComponentStatusClassName(status);
	if (labelClass) return labelClass;

	switch (status) {
		case "DRAFT":
			return "warning";
		case "VOID":
			return "danger";
		case "CLOSED":
			return "success";
	}
};

const StocktakingStatusLabel = ({ status }: Props) => {
	const { t } = useTranslation();
	let labelClass = getStatusClassName(status);

	const translation = t(`enums.common.status.${status}`);
	return <FormatResourceStatusLabel status={status} className={labelClass} translation={translation} />;
};

export default StocktakingStatusLabel;
